type OrganProps = {
  className: string;
  /** Accessible name: the organ is artwork, so it carries no text of its own. */
  label: string;
  /** Omitted where the body is not interactive, such as the PDF report. */
  onSelect?: () => void;
  children: React.ReactNode;
};

export default function Organ({
  className,
  label,
  onSelect,
  children,
}: OrganProps) {
  if (!onSelect) return <span className={className}>{children}</span>;

  return (
    <button
      type='button'
      className={className}
      onClick={onSelect}
      aria-label={label}
    >
      {children}
    </button>
  );
}
